<template>
  <a
    href="https://discord.com/discovery/applications/235148962103951360/store"
    target="_blank"
  >
    <b-button
      class="premium-cta discord-btn"
      size="lg"
      @click="trackPremiumCTA"
    >
      <img
        src="/img/brand/discord-mark-white.svg"
        alt="Discord"
        class="cta-svg-icon mr-2"
      />
      Buy on Discord
    </b-button>
  </a>
</template>

<script>
export default {
  name: "DiscordPremiumButton",
  methods: {
    trackPremiumCTA() {
      this.$emit("track", "discord");
    }
  }
};
</script> 
<style scoped>
.premium-cta {
  font-size: 1.3rem;
  font-weight: bold;
  padding: 0.7rem 2.2rem;
  border-radius: 2rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5em;
}
.discord-btn {
  background-color: #23272a !important;
  color: #fff !important;
  box-shadow: 0 2px 12px rgba(88, 101, 242, 0.08);
  font-weight: 600;
  border: 2px solid #23272a
}
.discord-btn:hover {
  background-color: #454FBF !important;
  border: 2px solid #454FBF;
  color: #fff !important;
}
.cta-svg-icon {
  height: 1.5em;
  width: 1.5em;
  vertical-align: middle;
  margin-bottom: 2px;
}


@media (max-width: 767.98px) {
  .premium-cta {
    font-size: 1rem;
    padding: 0.6rem 1.2rem;
  }
}
</style>